import { render, staticRenderFns } from "./RolesPermissions.vue?vue&type=template&id=7651fe08&"
import script from "./RolesPermissions.vue?vue&type=script&lang=js&"
export * from "./RolesPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports